<template>
  <v-dialog v-model="dialog"
    :content-class="`${dialog_class}`"
    @keydown.esc="closePopup">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on">
        <v-icon style="margin-bottom:-2px;" >history</v-icon> View history
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="documentDialog_title primary">
        <v-layout row wrap >
          <v-flex xs11>
            <p>History of <span v-text="entityName" /></p>
          </v-flex>
          <v-flex xs1 style="text-align: right;">
            <v-btn dark icon
              @click="closePopup()">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>

          <v-data-table
            :headers="header"
            :items="getWikiChangeRequestTable"
            item-key="change_request_field_id"
            :pagination.sync="pagination"
            :rows-per-page-items="[ 15, 50, 100 ]"
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="props">
              {{ props.header.text }}
              <v-tooltip bottom v-if="props.header.tooltip">
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-icon style="font-size: 16px;" color="grey lighten-1"
                    >info</v-icon>
                  </span>
                </template>
                <span v-html="props.header.tooltip">
                </span>
              </v-tooltip>
            </template>
            <!-- datas -->
            <template v-slot:items="props">
              <td>{{ props.item.requester_user_name }}</td>
              <td class="text-xs-left">{{ format(new Date(props.item.request_datetime), 'yyyy-MM-dd HH:mm:ss ') }}</td>
              <td class="text-xs-left">{{ props.item.request_type }}</td>
              <td class="text-xs-left">{{ props.item.target_type }}</td>
              <td class="text-xs-left">
                <span v-if="props.item.target_type === 'Content'" v-html="props.item.new_value" />
                <span v-else>{{ props.item.new_value }}</span>
              </td>
              <td class="text-xs-left">{{ props.item.note }}</td>
              <td class="text-xs-left">{{ props.item.comment }}</td>
            </template>
          </v-data-table>

      </v-card-text>
      <v-card-actions class="bottom_panel">
        <v-btn flat @click.native="closePopup()" class="primary">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import format from 'date-fns/format'
import { mapMutations, mapState } from 'vuex'
import GET_WIKI_CHANGE_REQUEST from '@/graphql/Wiki/GetWikiChangeRequest.gql'
export default {
  name: 'AttributesSection',
  props: ['entityName'],
  data () {
    return {
      getWikiChangeRequest: [],
      format,
      dialog: false,
      pagination: {
        sortBy: 'request_datetime',
        descending: true
      },
      header: [
        {
          text: 'User',
          value: 'requester_user_name',
          tooltip: null,
          align: 'left',
          sortable: false
        },
        {
          text: 'Requested date',
          value: 'request_datetime',
          tooltip: null,
          align: 'left',
          sortable: true,
        },
        // {
        //   text: 'Applied date',
        //   value: 'applied_datetime',
        //   tooltip: null,
        //   align: 'center',
        //   sortable: false
        // },
        {
          text: 'Type of operations',
          value: 'request_type',
          tooltip: null,
          align: 'left',
          sortable: false
        },
        {
          text: 'Type of data',
          value: 'target_type',
          tooltip: null,
          align: 'left',
          sortable: false
        },
        {
          text: 'New value',
          value: 'new_value',
          tooltip: null,
          align: 'left',
          sortable: false
        },
        {
          text: 'Note',
          value: 'note',
          tooltip: null,
          align: 'left',
          sortable: false
        },
        {
          text: 'Source of knowledge',
          value: 'comment',
          tooltip: null,
          align: 'left',
          sortable: false
        }
      ],
    }
  },
  computed: {
    ...mapState('wiki', ['entityId']),
    dialog_class () {
      return this.$vuetify.breakpoint.mdAndDown ? 'documentDialog wiki-entity-lower-md' : 'documentDialog wiki-entity'
    },
    getWikiChangeRequestTable () {
      const target_type_label = {
        'wiki_link': 'Link',
        'wiki_entity_type_rel': 'Entity type',
        'wiki_attribute': 'Attribute',
        'wiki_entity': 'Entity'
      }
      let newEntityObj = false
      let newEntityTypeObj = false
      const res = this.getWikiChangeRequest.map(cr => {
        let type = ""
        let value = ""
        let note = ""
        let entity1name = ""
        let entity2name = ""
        let change_request_field_id = false
        let target_type = ""
        cr.ChangeRequestFields.map(crf => {
          change_request_field_id = crf.change_request_field_id
          if (cr.target_type === "wiki_entity" && cr.request_type === "create") {
            if (crf.target_field === "entity_name") {
              newEntityObj = Object.assign({
                change_request_field_id: crf.change_request_field_id,
                requester_user_name: cr.requester_user_name,
                request_datetime: cr.request_datetime,
                request_type: cr.request_type,
                target_type: target_type_label[cr.target_type],
                new_value: crf.new_value_text,
                note: note,
                comment: cr.comment
              })
            }
            if (crf.target_field === "entity_type_id") {
              newEntityTypeObj = Object.assign({
                change_request_field_id: crf.change_request_field_id,
                requester_user_name: cr.requester_user_name,
                request_datetime: cr.request_datetime,
                request_type: cr.request_type,
                target_type: 'Entity type',
                new_value: crf.entity_type_name,
                note: note,
                comment: cr.comment
              })
            }
          } else if (cr.target_type === "wiki_entity" && cr.request_type === "update") {
            if (crf.target_field === "entity_rich_text") {
              value = crf.new_value_text
              target_type = "Content"
            }
            if (crf.target_field === "entity_name") {
              value = crf.new_value_text
              target_type = "Name"
            }
          }

          if (cr.target_type === "wiki_attribute") {
            if (crf.target_field === "attribute_type_id") {
              type = crf.attribute_type_name
            }
            if (crf.target_field === "attribute_value_text" && crf.new_value_text !== null) {
              value = crf.new_value_text
            }
            if (crf.target_field === "attribute_value_number" && crf.new_value_number !== null) {
              value = crf.new_value_number
            }
            if (crf.target_field === "attribute_note" && crf.new_value_text !== null) {
              note = crf.new_value_text
            }
          }

          if (cr.target_type === "wiki_link") {
            if (crf.target_field === "link_type_id") {
              type = crf.link_type_1to2_label
            }
            if (crf.target_field === "entity_1_id") {
              entity1name = crf.entity1name
            }
            if (crf.target_field === "entity_2_id") {
              entity2name = crf.entity2name
            }
            if (crf.target_field === "link_note" && crf.new_value_text !== null) {
              note = crf.new_value_text
            }
            if (cr.request_type === "delete") {
              type = crf.link_type_1to2_label
              entity1name = crf.entity1name
              entity2name = crf.entity2name
              note = crf.new_value_text
            }
          }
          if (cr.target_type === "wiki_entity_type_rel" && cr.request_type !== "delete") {
            if (crf.target_field === "entity_type_id") {
              value = crf.entity_type_name
            }
          }
          if (cr.target_type === "wiki_entity_type_rel" && cr.request_type === "delete") {
            if (crf.target_field === "entity_id") {
              value = crf.entity_type_name
            }
          }
        })

        if (cr.target_type === "wiki_attribute") {
          value = type + " " + value
        } else if (cr.target_type === "wiki_link") {
          value = entity1name + " " + type + " " + entity2name
        } else if (cr.target_type === "wiki_entity" && cr.request_type === "create") {
          return newEntityTypeObj
        }

        return Object.assign({
          change_request_field_id: change_request_field_id,
          requester_user_name: cr.requester_user_name,
          request_datetime: cr.request_datetime,
          request_type: cr.request_type,
          target_type: target_type && target_type || target_type_label[cr.target_type],
          new_value: value,
          note: note,
          comment: cr.comment
        })
      })

      if (newEntityObj){
        res.push(newEntityObj)
      }
      return res
    }
  },
  methods: {
    // ...mapMutations(['addError']),
    closePopup () {
      this.dialog = false
    },
  },
  apollo: {
    getWikiChangeRequest: {
      query: GET_WIKI_CHANGE_REQUEST,
      variables () {
        return {
          entity_id: parseInt(this.entityId)
        }
      },
      // candidates can change based on so many other actions
      // that it makes sense to recompute them every time
      fetchPolicy: 'network-only',
      skip () {
        return !this.entityId || !this.dialog
      }
    }
  }
}
</script>
<style>
.documentDialog_title{
  white-space: normal;
  -webkit-box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
  position: relative;
  -webkit-transition: none;
  transition: none;
  width: 100%;
  will-change: padding-left,padding-right;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: .02em;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0px 14px;
}
.documentDialog_title p {
  margin-top: 11px;
  margin-bottom: 3px;
}
</style>
